<template>
  <base-floating-card @close="close">
    <div id="edit-event-card">
      <div id="event-data-wrapper">
        <editable-field
          title="Event Title:"
          inputType="text"
          :processing="processing.title"
          :value="event.title"
          @scs-input="titleInput"
          @scs-blur="titleSubmit"
        />
        <editable-field
          title="Event Date:"
          inputType="date"
          :processing="processing.date"
          :value="eventDate"
          :formatter="formatDate"
          @scs-input="dateInput"
        />
        <editable-field
          title="Start Time:"
          inputType="time"
          :processing="processing.start_time"
          :value="startTime"
          :formatter="formatTime"
          @scs-input="startTimeInput"
        />
        <editable-field
          title="End Time:"
          inputType="time"
          :processing="processing.end_time"
          :value="endTime"
          :formatter="formatTime"
          @scs-input="endTimeInput"
        />
      </div>
      <div id="event-products-wrapper">
        <p class="scroller-heading">Products:</p>
        <div class="item-scroller">
          <item-tile
            v-for="(product, index) in eventProducts"
            :key="index"
            :text="product.name"
            :photo="product.photo"
            :input="product.type === 'Add-On'"
            :initialInputValue="
              product.type === 'Add-On' ? product.pricing.units : undefined
            "
            @input="addOnQuantity($event, product, index)"
            :selected="true"
            @primary-icon-clicked="removeProductFromEvent(product)"
          />
          <item-tile
            v-for="(product, index) in storeProducts"
            :key="index"
            :text="product.name"
            :photo="product.photo"
            @click="addProductToEvent(product)"
          />
          <item-tile
            v-if="!eventProducts.length && !storeProducts.length"
            text="None found. Build one!"
            @click="navigateToConfig"
          />
        </div>
      </div>
      <div id="event-adjustments-wrapper">
        <p class="scroller-heading">Adjustments:</p>
        <div class="item-scroller">
          <item-tile
            v-for="(adjustment, index) in eventAdjustments"
            :key="index"
            :text="adjustment.name"
            :selected="true"
            @primary-icon-clicked="removeAdjustmentFromEvent(product, index)"
          />
          <item-tile
            v-for="(adjustment, index) in storeAdjustments"
            :key="index"
            :text="adjustment.name"
            :photo="adjustment.photo"
            @click="addAdjustmentToEvent(adjustment)"
          />
          <item-tile
            v-if="!eventAdjustments.length && !storeAdjustments.length"
            text="None found. Build one!"
            @click="navigateToConfig"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import EditableField from "../../EditableField.vue";
import ItemTile from "../../ItemTile.vue";
import { formatDate, formatTime } from "../../../../Helpers/invoice.js";
export default {
  data() {
    return {
      title: undefined,
      processing: {
        title: false,
        start_time: false,
        end_time: false,
        date: false,
      },
    };
  },
  computed: {
    eventDate() {
      switch (this.event.api_version) {
        case "9-28-2022":
          return this.event.date;
        default:
          return this.event.data.date;
      }
    },
    startTime() {
      switch (this.event.api_version) {
        case "9-28-2022":
          return this.event.start_time;
        default:
          return this.event.data.startTime;
      }
    },
    endTime() {
      switch (this.event.api_version) {
        case "9-28-2022":
          return this.event.end_time;
        default:
          return this.event.data.endTime;
      }
    },
    services() {
      let services = this.$store.getters.services.filter((x) => {
        return !this.eventProducts.find((ef) => {
          return x.id === ef.id;
        });
      });
      return services.map((x) => ({
        ...x,
        type: "Service",
      }));
    },
    addOns() {
      let products = this.$store.getters.addOns.filter((x) => {
        return !this.eventProducts.find((ef) => {
          return x.id === ef.id;
        });
      });
      return products.map((x) => ({
        ...x,
        type: "Add-On",
      }));
    },
    packages() {
      let packages = this.$store.getters.packages.filter((x) => {
        return !this.eventProducts.find((ef) => {
          return x.id === ef.id;
        });
      });
      return packages.map((x) => ({
        ...x,
        type: "Package",
      }));
    },
    eventProducts() {
      switch (this.event.api_version) {
        case "9-28-2022":
          return this.event.invoice_products.map((x) => {
            return { ...x, selected: true };
          });
        default:
          return this.event.invoice.products.map((x) => {
            return { ...x, selected: true };
          });
      }
    },
    storeProducts() {
      return [...this.services, ...this.addOns, ...this.packages];
    },
    eventAdjustments() {
      switch (this.event.api_version) {
        case "9-28-2022":
          return this.event.invoice_adjustments;

        default:
          return this.event.invoice.adjustments;
      }
    },
    storeAdjustments() {
      return this.$store.getters.adjustments.filter((x) => {
        let identifier = x.id ? x.id : x.name;
        let eventMatch = this.eventAdjustments.findIndex((adj) => {
          return adj.name == identifier || adj.id == identifier;
        });
        return eventMatch === -1;
      });
    },
  },
  methods: {
    formatDate,
    formatTime,
    titleInput(val) {
      this.title = val;
    },
    async titleSubmit() {
      this.processing.title = true;
      let editPayload = {
        api_version: this.event.api_version,
        variable: "title",
        value: this.title,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
      };
      await this.$store.dispatch("editEvent", editPayload);
      this.processing.title = false;
    },
    async dateInput(val) {
      this.processing.date = true;
      let editPayload = {
        api_version: this.event.api_version,
        variable: "date",
        value: val,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
        subject: this.event,
      };
      await this.$store.dispatch("editEvent", editPayload);
      this.processing.date = false;
    },
    async startTimeInput(val) {
      this.processing.start_time = true;
      let editPayload = {
        api_version: this.event.api_version,
        variable: "start_time",
        value: val,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
      };
      await this.$store.dispatch("editEvent", editPayload);
      this.processing.start_time = false;
    },
    async endTimeInput(val) {
      if (val < new Date(this.endTime)) {
        val.setDate(val.getDate() + 1);
      }
      this.processing.end_time = true;
      let editPayload = {
        api_version: this.event.api_version,
        variable: "end_time",
        value: val,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
      };
      await this.$store.dispatch("editEvent", editPayload);
      this.processing.end_time = false;
    },
    removeProductFromEvent(products) {
      let parameters = {
        subject: this.event,
        api_version: this.event.api_version,
        variable: "invoice_products",
        value: products,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
        operation: "remove",
      };
      this.$store.dispatch("editEvent", parameters);
    },
    addProductToEvent(product) {
      if (product.type === "Add-On" && !product.pricing.units) {
        product.pricing.units = product.pricing.minUnits;
      }
      let parameters = {
        subject: this.event,
        api_version: this.event.api_version,
        variable: "invoice_products",
        value: product,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
        operation: "add",
      };
      this.$store.dispatch("editEvent", parameters);
    },
    removeAdjustmentFromEvent(adjustment, index) {
      // todo : add adjustment to config to test
      let parameters = {
        subject: this.event,
        api_version: this.event.api_version,
        variable: "invoice_adjustments",
        value: adjustment,
        index: index,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
        operation: "remove",
      };
      this.$store.dispatch("editEvent", parameters);
    },
    addAdjustmentToEvent(adjustment) {
      let parameters = {
        subject: this.event,
        api_version: this.event.api_version,
        variable: "invoice_adjustments",
        value: adjustment,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
        operation: "add",
      };
      this.$store.dispatch("editEvent", parameters);
    },
    addOnQuantity(event, product, index) {
      if (event) {
        product.pricing.units = event;
        let parameters = {
          subject: this.event,
          api_version: this.event.api_version,
          variable: "invoice_products",
          value: product,
          index: index,
          eventKey: {
            userId: this.event.userId,
            tenantId: this.event.tenantId,
          },
          operation: "edit",
        };
        this.$store.dispatch("editEvent", parameters);
      }
    },
    navigateToConfig() {
      // todo : setup router to go to config
    },
    close() {
      this.$emit("close");
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    EditableField,
    ItemTile,
  },
  emits: ["close"],
  props: ["event"],
};
</script>
<style scoped>
@media screen {
  #edit-event-card {
    /* width: 70vw; */
  }

  #event-data-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .item-scroller {
    width: 100%;
    display: flex;
    overflow: scroll;
  }

  .scroller-heading {
    font-size: 0.7rem;
    text-align: left;
  }
  @media (min-width: 800px) {
    #edit-event-card {
      width: 70vw;
    }

    #event-data-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
    }

    .item-scroller {
      width: 100%;
      display: flex;
      overflow: scroll;
    }

    .scroller-heading {
      font-size: 0.7rem;
      text-align: left;
    }
  }
}
</style>
